import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import navigate for redirection
import BackNavigation from "../../components/BackNavigation";
import Text from "../../components/Text";
import {
  Input,
  LoginFormWrapper,
  ModalButton,
  PlayerData,
  SideContainer,
  Signin,
  SigninHeader,
  SigninWrapper,
  ErrorMessage,
} from "./LoginPage.style";
import Button from "../../components/Button";
import { registerOrLogin } from "../../API/auth";
import { fetchUserProgress } from "../../API/progress";
import { fetchUserEmblem, getEmblemImagePath } from "../../API/emblem"; // ✅ Fetch user's emblem & generate path
import WarningModal from "../../components/Modals/WarningModal";
import ConnectImg from "../../assets/connect-btn.png";

const LoginPage = () => {
  const [name, setName] = useState("Μάριος Βλάχου");
  const [password, setPassword] = useState("092973");
  const [isOpen, setIsOpen] = useState(false); // For the Warning Modal
  const [errorMessage, setErrorMessage] = useState(""); // ✅ Error message state
  const navigate = useNavigate(); // For handling navigation

  /* ******************************************
          BACKEND INTEGRATION
  ****************************************** */
          useEffect(() => {
            console.log("🔄 Clearing sessionStorage on login page load");
            sessionStorage.clear();
          }, []);
          
          

  const handleLogin = async () => {
    console.log("Login clicked");

    try {
      console.log("Starting login/registration request...");
      const loginResult = await registerOrLogin(name, password);

      if (!loginResult.success) {
        console.log("Login/registration failed:", loginResult.message);
        setErrorMessage("Η σύνδεση απέτυχε. Δοκιμάστε ξανά.");
        return;
      }

      console.log("Login successful. Received userId:", loginResult.user_id);

      // ✅ Store user ID in sessionStorage
      sessionStorage.setItem("user_id", loginResult.user_id);
      console.log("Stored user ID in sessionStorage:", loginResult.user_id);

      // ✅ Fetch user emblem & color
      console.log("Fetching user emblem...");
      const emblemResult = await fetchUserEmblem();

      console.log("Fetched emblem result:", emblemResult);

      if (emblemResult.success && emblemResult.data?.emblem_id) {
        const { emblem_id, color } = emblemResult.data;

        // ✅ Store emblem ID and color separately
        sessionStorage.setItem("emblem_id", emblem_id);
        sessionStorage.setItem("color", color);

        // ✅ Generate emblem path dynamically
        const emblemPath = getEmblemImagePath(emblem_id, color);
        sessionStorage.setItem("emblem", emblemPath);

        console.log(`Existing user detected. Redirecting to play page.`);
        navigate("/play");
        return;
      }

      console.log(`New user detected. Redirecting to customize page.`);
      navigate("/customize", { state: { userId: loginResult.user_id } });
    } catch (error) {
      console.error(
        "Unexpected error during login/registration:",
        error.message
      );
    }
  };

  

  return (
    <LoginFormWrapper>
      <BackNavigation mode="" url="/" />
      <SigninWrapper>
        <Signin>
          <SigninHeader>
            <Text fontSize="40px" fontFamily="'Source Serif 4'" fontWeight="700">
              Σύνδεση
            </Text>
            <Text fontSize="16px" fontFamily="Manrope" fontWeight="600">
              Συνδεθείτε στο παιχνίδι
            </Text>
          </SigninHeader>
          <PlayerData>
            <div style={{ display: "flex", flexDirection: "row", gap: "3px" }}>
              <Text
                fontFamily="Manrope"
                fontSize="14px"
                fontWeight="700"
                color="#FFFBEC"
              >
                Όνομα
              </Text>
              <Text
                fontFamily="Manrope"
                fontSize="14px"
                fontWeight="400"
                color="#FFFBEC"
              >
                (4 έως 16 χαρακτήρες)
              </Text>
            </div>

            <Input
              type="text"
              value={name}
              onChange={({ target }) => setName(target.value)}
            />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "3px",
                marginTop: "10px",
              }}
            >
              <Text
                fontFamily="Manrope"
                fontSize="14px"
                fontWeight="700"
                color="#FFFBEC"
              >
                Κωδικός
              </Text>
              <Text
                fontFamily="Manrope"
                fontSize="14px"
                fontWeight="400"
                color="#FFFBEC"
              >
                (4 έως 16 χαρακτήρες)
              </Text>
            </div>

            <Input
              type="text"
              value={password}
              onChange={({ target }) => setPassword(target.value)}
            />

            {/* ✅ Display error message */}
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

            <ModalButton onClick={() => setIsOpen(!isOpen)}>
              Παράλειψη σύνδεσης
            </ModalButton>
            <WarningModal open={isOpen} onClose={() => setIsOpen(!isOpen)} />

            <div style={{ marginTop: "40px" }}>
            <Button
              className="connect"
              imgurl={ConnectImg}
              onClick={handleLogin}
              width="183px"
            />

            </div>
          </PlayerData>
        </Signin>
        <SideContainer></SideContainer>
      </SigninWrapper>
    </LoginFormWrapper>
  );
};

export default LoginPage;
